import { createSelector } from 'reselect';

import { TInitialState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

export const getSelectedProductsIds = createSelector(
    [
        (state: TInitialState) => state.productFilters,
    ],
    (filters) => {
        const productIdsArray = new Set<EProductsId>([EProductsId.internet]);

        filters
            .filter(filter => filter.checked)
            .forEach(({ id }) => {
                if (typeof id === 'undefined') {
                    productIdsArray.add(EProductsId.tv);
                } else {
                    productIdsArray.add(id);
                }
            });

        return [...productIdsArray];
    },
);
